<style>
.invalid-feedback { display: block; }
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SearchableSelect from "@/components/SearchableSelect";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { required, email, helpers, requiredIf } from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify';

const numericOnly = helpers.regex('numericOnly', /^[0-9]*$/);

export default {
  name: 'KBCreate',
  page() {
    return { title: this.pageTitle };
  },
  components: { Layout, PageHeader, SearchableSelect },
  data() {
    return {
      title: "ÖN KAYIT EKLE",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "ÖN KAYIT EKLE", active: true },
      ],
      openLckUsername: false,
      pageTitle: 'Ön Kayıt Ekle',
      form: {
        username_ek: '',
        _installment: false,
        type: 'b',
        tariff_type: 'WIFI',
        phonenumber: '',
        phonenumber2: '',
        musteri_tipi: 'T-SIRKET',
        companyname: '',
        taxnum: '',
        taxoffice: '',
      },
      submitted: false,
      apartmant: '',
      ilList: [],
      bucakList: [],
      apartmentList: [],
      tariffList: [],
      seciliTarife: { price: 0 },
      installments: [],
      odenecek_tutar: 0,
      secili: [],
      taksitli_fiyat: 0,
      odenen_taksitler: [],
      summaryStyle: {},
    };
  },
  validations: {
    form: {
      phonenumber: { required, numericOnly },
      phonenumber2: { required, numericOnly },
      fname: { required },
      lname: { required },
      adress: { required },
      province: { required },
      township: { required },
      tariff_id: { required },
      email: { email },
      companyname: {
        required: requiredIf(function () { return this.form.type === 'k'; }),
      },
      taxnum: {
        required: requiredIf(function () { return this.form.type === 'k'; }),
      },
      taxoffice: {
        required: requiredIf(function () { return this.form.type === 'k'; }),
      },
    },
  },
  computed: {
    ...mapGetters('authfack', ['settings', 'userdata']),
    isCorporate() {
      return this.form.type === 'k';
    },
    nameLabel() {
      return this.isCorporate ? 'Yetkili Adı' : 'İsim';
    },
    surnameLabel() {
      return this.isCorporate ? 'Yetkili Soyadı' : 'Soyisim';
    },
    displayPrice() {
      if (this.form._installment && this.installments && this.installments.length) {
        return this.formatTL(this.odenecek_tutar);
      }
      return this.formatTL(this.seciliTarife.price) || '0,00 TL';
    },
  },
  mounted() {
    this.setSelected({ id: 0 }, 'il');
    this.getTariffList();
    this.getApartmentList();
    this.getUsername();
    this.$nextTick(() => this.pinSummary());
    window.addEventListener('scroll', this.pinSummary, true);
    window.addEventListener('resize', this.pinSummary);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.pinSummary, true);
    window.removeEventListener('resize', this.pinSummary);
  },
  watch: {
    secili(val) {
      this.odenen_taksitler = val.map(e => e.num);
      this.taksitli_fiyat = val.reduce((sum, a) => parseFloat(sum) + parseFloat(a.price), 0);
    },
    apartmant(val) {
      if (val && val.id) {
        this.selectApartmant();
      } else {
        this.form = {
          ...this.form,
          apartmant_id: null,
          tariff_id: null,
          _installment: false,
        };
      }
      this.seciliTarife = { price: 0 };
      this.installments = [];
      this.odenecek_tutar = 0;
      this.secili = [];
      this.taksitli_fiyat = 0;
      this.getTariffList();
    },
    'form.type'(val) {
      if (val !== 'k') {
        this.form.companyname = '';
        this.form.taxnum = '';
        this.form.taxoffice = '';
        this.form.musteri_tipi = 'G-SAHIS';
      } else {
        this.form.musteri_tipi = 'T-SIRKET';
      }
      this.$nextTick(() => this.pinSummary());
    },
    'form.phonenumber': {
      immediate: true,
      handler(val) {
        const onlyNums = String(val == null ? '' : val).replace(/\D/g, '');
        if (this.form.phonenumber !== onlyNums) this.form.phonenumber = onlyNums;
        if (this.form.phonenumber2 !== onlyNums) this.form.phonenumber2 = onlyNums;
      },
    },
    'form.phonenumber2': {
      handler(val) {
        const onlyNums = String(val == null ? '' : val).replace(/\D/g, '');
        if (this.form.phonenumber2 !== onlyNums) this.form.phonenumber2 = onlyNums;
      },
    },
  },
  methods: {
    save() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return;

      Vue.swal({
        title: 'Ön başvuru eklensin mi?',
        showCancelButton: true,
        cancelButtonText: 'İptal',
        confirmButtonText: 'Ekle',
      }).then((result) => {
        if (!result.value) return;

        this.$http.post('members/store', {
          ...this.form,
          selected: this.odenen_taksitler,
        }).then((response) => {
          if (response.data.error) {
            return notify.error(response.data.message);
          }
          this.resetForm();
          notify.success('Başarılı Eklendi');
          this.$v.form.$reset();
        });
      });
    },
    resetForm() {
      const username = this.form.username;
      this.form = {
        username,
        username_ek: '',
        _installment: false,
        type: 'b',
        tariff_type: 'WIFI',
        phonenumber: '',
        phonenumber2: '',
        musteri_tipi: 'T-SIRKET',
        companyname: '',
        taxnum: '',
        taxoffice: '',
      };
      this.apartmant = '';
      this.installments = [];
      this.odenecek_tutar = 0;
      this.seciliTarife = { price: 0 };
      this.secili = [];
      this.submitted = false;
      this.getUsername();
      this.getTariffList();
    },
    showUpdate() {
      return (this.form && Object.prototype.hasOwnProperty.call(this.form, 'type'))
        || this.$route.name === 'on-kayit-ekle';
    },
    async getTariffList() {
      const tariff_type = this.form.tariff_type;
      const hasApartment = !!this.form.apartmant_id;
      await this.$http.post('/tariff?output=one&group=true&fields=tariffs.id,tariffs.name,tariffs.price,tariffs.installment_price,tariffs.installment&stage=new&apt=' + hasApartment + '&tariff_type=' + tariff_type)
        .then(response => { this.tariffList = response.data; });
    },
    async getApartmentList() {
      await this.$http.post('/apartman?output=one&fields=apartments.id,apartments.name')
        .then(resp => { this.apartmentList = resp.data; })
        .catch(() => {});
    },
    getUsername() {
      this.$http.get('/services/username-create')
        .then(resp => { this.form = { ...this.form, username: resp.data }; })
        .catch(() => {});
    },
    async setSelected(val, event) {
      const object = event + 'List';
      const { id } = val;
      const response = await this.$http.post(`/address/${event}/${id}`);
      if (response.data.error) return;
      this[object] = response.data;
    },
    selectApartmant() {
      this.form = {
        ...this.form,
        apartmant_id: this.apartmant.id,
        adress: this.apartmant.address,
        province: this.apartmant.district_name,
        township: this.apartmant.quarter_name,
      };
    },
    tarifeSec(pick) {
      if (!pick || !pick.id) return;
      this.taksitli_fiyat = 0;
      this.secili = [];
      this.installments = pick.installments;
      this.odenecek_tutar = pick.installment_price;
      this.form = { ...this.form, tariff_id: pick.id };
      this.seciliTarife = pick;
    },
    onProvinceSelect(id) {
      const found = this.ilList.find(o => o.id === id);
      if (found) this.setSelected(found, 'bucak');
    },
    filterTariff(option, query) {
      const name = (option.name || '').toString().toLowerCase();
      const price = (option.price || '').toString().toLowerCase();
      return name.indexOf(query) !== -1 || price.indexOf(query) !== -1;
    },
    setCustomerType(type) {
      this.form.type = type;
    },
    setTariffType(type) {
      this.form.tariff_type = type;
      this.getTariffList();
    },
    pinSummary() {
      const anchor = this.$refs.sideAnchor;
      if (!anchor || window.innerWidth < 992) {
        this.summaryStyle = {};
        return;
      }

      const rect = anchor.getBoundingClientRect();
      const topnav = document.querySelector('.topnav');
      const topbar = document.querySelector('#page-topbar');
      let menuBottom = 16;
      if (topnav) {
        menuBottom = Math.ceil(topnav.getBoundingClientRect().bottom) + 12;
      } else if (topbar) {
        menuBottom = Math.ceil(topbar.getBoundingClientRect().bottom) + 12;
      }

      // Form yanındaki doğal konumdan başla; menünün altına yapışmasın
      let top = rect.top;
      if (top < menuBottom) top = menuBottom;

      const main = this.$refs.formMain;
      const summaryEl = this.$refs.summaryBox;
      if (main && summaryEl) {
        const mainBottom = main.getBoundingClientRect().bottom;
        const maxTop = mainBottom - summaryEl.offsetHeight;
        if (top > maxTop) top = Math.max(menuBottom, maxTop);
      }

      this.summaryStyle = {
        position: 'fixed',
        top: `${Math.round(top)}px`,
        left: `${Math.round(rect.left)}px`,
        width: `${Math.round(rect.width)}px`,
        zIndex: 40,
      };
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="create-page">
      <div class="create-page__inner">
        <div class="create-page__main" ref="formMain">
          <div class="create-card">
            <div class="create-card__head">
              <div>
                <h2 class="create-card__title">Ön Kayıt Formu</h2>
                <p class="create-card__sub">Bireysel veya kurumsal abone ön kaydı</p>
              </div>
              <div class="create-type">
                <button
                  type="button"
                  class="create-type__btn"
                  :class="{ active: form.type === 'b' }"
                  @click="setCustomerType('b')"
                >Bireysel</button>
                <button
                  type="button"
                  class="create-type__btn"
                  :class="{ active: form.type === 'k' }"
                  @click="setCustomerType('k')"
                >Kurumsal</button>
              </div>
            </div>

            <form class="create-form" @submit.prevent="save">
              <section class="create-section">
                <div class="create-section__title">Hesap / Kişi</div>
                <div class="row g-3">
                  <div class="col-md-12">
                    <label class="create-label">Kullanıcı Adı</label>
                    <div class="input-group">
                      <input
                        id="username"
                        v-model="form.username"
                        type="text"
                        class="form-control create-input"
                        placeholder="Kullanıcı Adı"
                        :readonly="!openLckUsername"
                      >
                      <button
                        v-if="settings.domain_update"
                        class="btn btn-outline-secondary"
                        type="button"
                        @click="openLckUsername = !openLckUsername"
                      >
                        <i class="fa fa-lock"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">{{ nameLabel }}</label>
                    <input
                      v-model="form.fname"
                      type="text"
                      class="form-control create-input"
                      :placeholder="nameLabel"
                      :class="{ 'is-invalid': submitted && $v.form.fname.$error }"
                    >
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">{{ surnameLabel }}</label>
                    <input
                      v-model="form.lname"
                      type="text"
                      class="form-control create-input"
                      :placeholder="surnameLabel"
                      :class="{ 'is-invalid': submitted && $v.form.lname.$error }"
                    >
                  </div>
                </div>
              </section>

              <section class="create-section" v-if="isCorporate">
                <div class="create-section__title">Kurumsal Bilgiler</div>
                <div class="row g-3">
                  <div class="col-md-12">
                    <label class="create-label">Şirket Unvanı</label>
                    <input
                      v-model="form.companyname"
                      type="text"
                      class="form-control create-input"
                      placeholder="Şirket / Firma unvanı"
                      :class="{ 'is-invalid': submitted && $v.form.companyname.$error }"
                    >
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">Vergi No</label>
                    <input
                      v-model="form.taxnum"
                      type="text"
                      class="form-control create-input"
                      placeholder="Vergi numarası"
                      :class="{ 'is-invalid': submitted && $v.form.taxnum.$error }"
                    >
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">Vergi Dairesi</label>
                    <input
                      v-model="form.taxoffice"
                      type="text"
                      class="form-control create-input"
                      placeholder="Vergi dairesi"
                      :class="{ 'is-invalid': submitted && $v.form.taxoffice.$error }"
                    >
                  </div>
                </div>
              </section>

              <section class="create-section">
                <div class="create-section__title">İletişim</div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="create-label">
                      Telefon 1 <span class="create-hint">SMS bu numaraya gider</span>
                    </label>
                    <input
                      v-model="form.phonenumber"
                      type="tel"
                      class="form-control create-input"
                      placeholder="Telefon 1"
                      :class="{ 'is-invalid': submitted && $v.form.phonenumber.$error }"
                    >
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">Telefon 2</label>
                    <input
                      v-model="form.phonenumber2"
                      type="tel"
                      class="form-control create-input"
                      placeholder="Telefon 2"
                      :class="{ 'is-invalid': submitted && $v.form.phonenumber2.$error }"
                    >
                  </div>
                  <div class="col-md-12">
                    <label class="create-label">E-Posta</label>
                    <input
                      v-model="form.email"
                      type="text"
                      class="form-control create-input"
                      placeholder="E-Posta"
                      :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                    >
                  </div>
                </div>
              </section>

              <section class="create-section">
                <div class="create-section__title">Adres</div>
                <div class="row g-3">
                  <div class="col-md-12">
                    <label class="create-label">Apartman Sistemi</label>
                    <SearchableSelect
                      label="name"
                      v-model="apartmant"
                      :options="apartmentList"
                      placeholder="Apartman ara..."
                      searchable
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">İlçe</label>
                    <SearchableSelect
                      placeholder="İlçe ara..."
                      label="name"
                      v-model="form.province"
                      :options="ilList"
                      :reduceFn="o => o.id"
                      searchable
                      @input="onProvinceSelect"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="create-label">Bölge</label>
                    <SearchableSelect
                      placeholder="Bölge ara..."
                      label="name"
                      v-model="form.township"
                      :options="bucakList"
                      :reduceFn="o => o.id"
                      searchable
                    />
                  </div>
                  <div class="col-md-12">
                    <label class="create-label">Adres Detay</label>
                    <input
                      v-model="form.adress"
                      type="text"
                      class="form-control create-input"
                      placeholder="Sokak, bina, daire vb."
                      :class="{ 'is-invalid': submitted && $v.form.adress.$error }"
                    >
                  </div>
                  <div class="col-md-12">
                    <label class="create-label">Açıklama</label>
                    <input
                      v-model="form.description"
                      type="text"
                      class="form-control create-input"
                      placeholder="Opsiyonel açıklama"
                    >
                  </div>
                </div>
              </section>

              <section class="create-section">
                <div class="create-section__title">Servis</div>
                <div class="create-service-tabs mb-3">
                  <button
                    type="button"
                    class="create-service-tabs__btn"
                    :class="{ active: form.tariff_type === 'WIFI' }"
                    @click="setTariffType('WIFI')"
                  >Wireless</button>
                  <button
                    type="button"
                    class="create-service-tabs__btn"
                    :class="{ active: form.tariff_type === 'ADSL' }"
                    @click="setTariffType('ADSL')"
                  >ADSL</button>
                  <button
                    type="button"
                    class="create-service-tabs__btn"
                    :class="{ active: form.tariff_type === 'FIBER' }"
                    @click="setTariffType('FIBER')"
                  >Fiber</button>
                </div>
                <SearchableSelect
                  placeholder="Servis ara..."
                  v-model="seciliTarife"
                  :options="tariffList"
                  label="name"
                  searchable
                  :filterFn="filterTariff"
                  @input="tarifeSec"
                >
                  <template slot="option" slot-scope="{ option }">
                    <div class="d-flex justify-content-between w-100">
                      <span>{{ option.name }}</span>
                      <span class="text-primary fw-semibold">{{ option.price }} TL</span>
                    </div>
                  </template>
                </SearchableSelect>
                <div v-if="submitted && $v.form.tariff_id.$error" class="invalid-feedback">
                  Servis seçimi zorunludur.
                </div>

                <div class="mt-3" v-if="installments && installments.length > 0">
                  <label class="create-check">
                    <input type="checkbox" v-model="form._installment">
                    <span>Taksitli satış yapmak istiyorum</span>
                  </label>
                  <div v-if="form._installment" class="mt-2">
                    <div class="alert alert-warning py-2 mb-2">
                      Taksit ödemesini kurulum bekleyenlerden yapınız.
                    </div>
                    <table class="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr v-for="(installment, i) in installments" :key="i">
                          <td class="text-end">{{ installment.num }}. Taksit</td>
                          <td>{{ installment.price }} TL</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>

              <div class="create-footer">
                <div class="create-price">
                  <span>Ödenecek Ücret</span>
                  <strong>{{ displayPrice }}</strong>
                </div>
                <button class="btn btn-primary create-submit" type="submit">
                  Ön Kayıt Ekle
                </button>
              </div>
            </form>
          </div>
        </div>

        <aside class="create-page__side" ref="sideAnchor">
          <div class="create-summary" ref="summaryBox" :style="summaryStyle">
            <div class="create-summary__badge" :class="isCorporate ? 'is-corp' : 'is-ind'">
              {{ isCorporate ? 'Kurumsal' : 'Bireysel' }}
            </div>
            <h3>Ödeme Özeti</h3>
            <ul>
              <li>
                <span>Ücret</span>
                <strong>{{ displayPrice }}</strong>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.create-page {
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 0 12px 28px;
}

.create-page__inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 250px;
  gap: 18px;
  align-items: start;
}

.create-page__side {
  position: relative;
  align-self: start;
  min-height: 260px;
}

.create-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}

.create-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.create-card__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
}

.create-card__sub {
  margin: 3px 0 0;
  font-size: 0.8rem;
  color: #64748b;
}

.create-type {
  display: inline-flex;
  padding: 3px;
  border-radius: 10px;
  background: #e2e8f0;
  gap: 3px;
}

.create-type__btn {
  border: 0;
  background: transparent;
  padding: 7px 14px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
}

.create-type__btn.active {
  background: #0f172a;
  color: #fff;
}

.create-form {
  padding: 6px 20px 18px;
}

.create-section {
  padding: 14px 0;
  border-bottom: 1px dashed #e2e8f0;
}

.create-section:last-of-type {
  border-bottom: 0;
}

.create-section__title {
  margin-bottom: 10px;
  font-size: 0.84rem;
  font-weight: 700;
  color: #1e293b;
}

.create-label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
}

.create-hint {
  margin-left: 4px;
  font-size: 0.68rem;
  font-weight: 500;
  color: #ef4444;
}

.create-input {
  min-height: 38px;
  border-radius: 9px;
  border-color: #e2e8f0;
  background: #f8fafc;
}

.create-input:focus {
  background: #fff;
  border-color: #0891b2;
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.1);
}

.create-service-tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.create-service-tabs__btn {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #475569;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}

.create-service-tabs__btn.active {
  background: #0891b2;
  border-color: #0891b2;
  color: #fff;
}

.create-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #334155;
  cursor: pointer;
}

.create-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  margin-top: 8px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
}

.create-price span {
  display: block;
  font-size: 0.7rem;
  color: #64748b;
  text-transform: uppercase;
}

.create-price strong {
  font-size: 1.2rem;
  color: #0f172a;
}

.create-submit {
  min-width: 150px;
  height: 42px;
  border-radius: 10px;
  font-weight: 600;
  background: linear-gradient(135deg, #0891b2, #2563eb);
  border: 0;
}

.create-summary {
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 14px;
  padding: 16px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
}

.create-summary__badge {
  display: inline-flex;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.create-summary__badge.is-ind {
  background: rgba(34, 211, 238, 0.15);
  color: #67e8f9;
}

.create-summary__badge.is-corp {
  background: rgba(251, 191, 36, 0.18);
  color: #fbbf24;
}

.create-summary h3 {
  font-size: 0.92rem;
  margin-bottom: 10px;
  color: #fff;
}

.create-summary ul {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
}

.create-summary li {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 0.78rem;
}

.create-summary li span {
  color: #94a3b8;
}

.create-summary li strong {
  color: #f8fafc;
  text-align: right;
  word-break: break-word;
}

.create-summary__note {
  margin: 0;
  font-size: 0.7rem;
  line-height: 1.45;
  color: #94a3b8;
}

@media (max-width: 991.98px) {
  .create-page {
    max-width: 720px;
  }

  .create-page__inner {
    grid-template-columns: 1fr;
  }

  .create-page__side {
    position: static;
    order: -1;
    min-height: 0;
  }

  .create-card__head {
    flex-wrap: wrap;
  }
}
</style>
